import * as service from '../../service/CallApi';
import { UserManageVerifyRequest, UserVerifyRequest } from '../../models/RequestModel';
import { initVerificationResponse, VerificationResponse } from '../../models/ResponseModel';

const types = {
  VERIFICATION_PENDING_FETCH: 'VERIFICATION_PENDING_FETCH',
  VERIFICATION_FETCH_SUCCESS: 'VERIFICATION_FETCH_SUCCESS',
  VERIFICATION_FETCH_FAILURE: 'VERIFICATION_FETCH_FAILURE',
};

export const actions = {
  postVerification: async (dispatch: any, request: UserVerifyRequest | UserManageVerifyRequest) => {
    dispatch({ type: types.VERIFICATION_PENDING_FETCH });
    try {
      const json: VerificationResponse = await service.postVerification(request);
      if (typeof json?.accessToken !== 'string' || !json.accessToken.trim()) {
        throw new Error('Verification response is missing an access token');
      }
      dispatch({ type: types.VERIFICATION_FETCH_SUCCESS, payload: json });
      return json;
    } catch (error) {
      dispatch({ type: types.VERIFICATION_FETCH_FAILURE });
      throw error;
    }
  },
  setVerification: async (dispatch: any, request: VerificationResponse) => {
    dispatch({ type: types.VERIFICATION_PENDING_FETCH });
    if (typeof request?.accessToken !== 'string' || !request.accessToken.trim()) {
      dispatch({ type: types.VERIFICATION_FETCH_FAILURE });
      throw new Error('Verification response is missing an access token');
    }
    dispatch({ type: types.VERIFICATION_FETCH_SUCCESS, payload: request });
    return request;
  },
};

const initialState = {
  accessToken: initVerificationResponse(),
  isFetching: false,
};

export const userVerificationReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case types.VERIFICATION_FETCH_SUCCESS:
      return {
        ...state,
        accessToken: action.payload,
        isFetching: false,
      };
    case types.VERIFICATION_FETCH_FAILURE:
      return {
        ...state,
        isFetching: false,
      };
    case types.VERIFICATION_PENDING_FETCH:
      return {
        ...state,
        isFetching: true,
      };
    default:
      return state;
  }
};
